import React, { useState, useEffect } from "react";
import Select from 'react-select';
import axios from "axios";
import { IoPrintOutline } from "react-icons/io5";
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";

function ReportTicketList() {
    const [reporttickets, setReportTickets] = useState([]);
    const [isVisible, setIsVisible] = useState(false);

    const [start_date, setStartDate] = useState('');
    const [keywordStartDate, setKeywordStartDate] = useState("");

    const [end_date, setEndDate] = useState('');
    const [keywordEndDate, setKeywordEndDate] = useState("");

    const [optioncust, setOptionCust] = useState([]);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const [selectcustomer, setSelectCustomer] = useState(null);
    const [keywordcust, setKeywordCust] = useState("");
    const [querycust, setQueryCust] = useState("");

    const [keywordstatus, setKeywordStatus] = useState("");
    const [querystatus, setQueryStatus] = useState("");

    const componentRef = useRef();

    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const API_KEY = process.env.REACT_APP_API_KEY;

    const toggleTableVisibility = () => {
        setIsVisible(true);
    };

    const handlePrint = useReactToPrint({
        documentTitle: 'Title',
        contentRef: componentRef,
    })

    const customStyles = {
        control: (base, state) => ({
        ...base,
        minHeight: '29px', // Adjust the minimum height of the control
        fontSize: '14px', // Adjust the font size
        }),
        valueContainer: (base) => ({
        ...base,
        height: '29px', // Set the specific height for the value container
        padding: '0 8px', // Adjust padding as needed
        }),
        clearIndicator: (base) => ({
        ...base,
        padding: '0 4px', // Adjust padding for the clear indicator
        }),
        dropdownIndicator: (base) => ({
        ...base,
        padding: '0 4px', // Adjust padding for the dropdown indicator
        }),
        menuList: (base) => ({
        ...base,
        fontSize: '14px', // Adjust the font size of the dropdown menu
        }),
    };

    const SmallSelect = (props) => (
        <Select styles={customStyles} {...props} />
    );

    const handleCustomerChange = (selectedOption) => {
        if (!selectedOption) {
        setQueryCust("");
        setSelectCustomer(null);
        setKeywordCust("");
        //console.error("Event or event target is null/undefined");
        return; // Exit the function gracefully
        }
        const newValue = selectedOption;
        setQueryCust(newValue.value);
        setSelectCustomer(newValue);
        //console.log('Option selected:', newValue);
    };

    useEffect(() => {
        const fetchOptionCust = async () => {
            setIsLoading(true);
            try {
                // Replace with your actual Node.js API endpoint
                const resultcust = await axios.get(`${API_BASE_URL}/client`, {
                    headers: {
                        'X-API-Key': API_KEY
                    },
                }); 
                const datacust = resultcust.data;

                // Map the API data to the format react-select expects: { value: '', label: '' }
                const formattedOptionCust = datacust.map(item => ({
                    value: item.id,
                    label: item.name,
                }));

                setOptionCust(formattedOptionCust);
                setError(null);
            } catch (err) {
                setError('Failed to load options');
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        };
        const getReportTickets = async () => {
            const response = await axios.get(
            `${API_BASE_URL}/reporttickets?search_customer=${keywordcust}&search_status=${keywordstatus}&startdate=${keywordStartDate}&enddate=${keywordEndDate}`, {
                headers: {
                    'X-API-Key': API_KEY
                },
            });
            //console.log(response.data);
            setReportTickets(response.data);
        };
        fetchOptionCust();
        getReportTickets();
    
    }, [keywordStartDate, keywordEndDate, keywordcust, keywordstatus]);

    

    const searchData = (e) => {
        e.preventDefault();
        //console.log(start_date);
        setKeywordCust(querycust);
        setKeywordStatus(querystatus);
        setKeywordStartDate(start_date);
        setKeywordEndDate(end_date);
        toggleTableVisibility();
    };

return (
    <div className="container">
        <h1 className="title is-size-5">Report Tickets</h1>                 
        <form onSubmit={searchData}>
            <div className="columns">
                <div className="column is-2">
                    <div className="field">
                        <label className="label">Start_Date</label>
                        <div className="control">
                            <input className="input is-small"
                                type="date"
                                id="start_date"
                                name="start_date"
                                value={start_date} // Controlled component
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className="column is-2">
                    <div className="field">
                        <label className="label">End_Date</label>
                        <div className="control">
                            <input className="input is-small"
                                type="date"
                                id="end_date"
                                name="end_date"
                                value={end_date} // Controlled component
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className="column is-3">
                    <div className="field">
                        <label className="label">Customer</label>
                        <div className="control">
                            <SmallSelect
                                value={selectcustomer}
                                onChange={handleCustomerChange}
                                options={optioncust}
                                isLoading={isLoading}
                                isClearable={true} 
                                placeholder="ALL"
                            />
                        </div>
                    </div>
                </div>
                <div className="column is-2">
                    <div className="field">
                        <label className="label">Status</label>
                        <div className="control">
                            <div className="select is-small is-fullwidth">
                            <select
                                value={querystatus}
                                onChange={(e) => setQueryStatus(e.target.value)}
                                >
                                <option value="">ALL</option>
                                <option value="OPEN">OPEN</option>
                                <option value="CLOSED">CLOSED</option>
                                <option value="REPAIRED">REPAIRED</option>
                            </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="column is-1">
                    <div className="field">
                        <label className="label">&nbsp;</label>
                        <div className="control">
                            <button type="submit" className="button is-small is-info">
                            Search
                            </button>
                        </div>
                    </div>
                </div>
                <div className="column is-1">
                    <div className="field">
                        <label className="label">&nbsp;</label>
                        <div className="control">
                           <a className="button is-small is-link mr-2" onClick={handlePrint}><IoPrintOutline />&nbsp;Print</a>
                        </div>
                    </div>
                </div>
            </div>
        </form>  

        <div className="table-container mt-4">
            <table className="table is-fullwidth is-size-7" ref={componentRef}>
                <thead>
                    <tr>
                    <th>No</th>
                    <th className="has-text-centered">Ticket_ID</th>
                    <th className="has-text-centered">Description</th>
                    <th className="has-text-centered">Product_Name</th>
                    <th className="has-text-centered">Serial_Number</th>
                    <th className="has-text-centered">Customer</th>
                    <th className="has-text-centered">Status</th>
                    <th className="has-text-centered">Time_Open</th>
                    <th className="has-text-centered">Time_Close</th>          
                    </tr>
                </thead>
                {isVisible && (
                <tbody>
                    {reporttickets.map((item, index) => (
                    <tr key={item.uuid}>
                        <td>{index + 1}</td>
                        <td className="has-text-centered">{item.ticket_id}</td>
                        <td>{item.description}</td>
                        <td>{item.product.name}</td>
                        <td>{item.product.serialnumber}</td>
                        <td>{item.client.name}</td>
                        <td>{item.status}</td>
                        <td className="has-text-centered">
                            {new Date(item.time_open).toLocaleDateString('id', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                            hour: 'numeric',
                            minute: 'numeric',
                            hour12: false,
                            })}                    
                        </td>
                        <td className="has-text-centered">
                            {item.time_close ? (
                                new Date(item.time_close).toLocaleDateString('id', {
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric',
                                hour: 'numeric',
                                minute: 'numeric',
                                hour12: false,
                                })
                            ) : (
                                <p>-</p>
                            )}
                        </td>
                    </tr>
                    ))}
                </tbody>
                )}
            </table>
           
        </div>
    </div>
  );
}

export default ReportTicketList;
